export function formatCustomFieldDescription(description: string): string {
  const documentFragment = new DOMParser().parseFromString(description, 'text/html');

  documentFragment.querySelectorAll('a').forEach(link => {
    if (!link.hasAttribute('target')) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });

  const textNodes: Text[] = [];
  const walker = documentFragment.createTreeWalker(documentFragment.body, NodeFilter.SHOW_TEXT);
  let node = walker.nextNode();
  while (node) {
    if (!node.parentElement?.closest('a, script, style')) textNodes.push(node as Text);
    node = walker.nextNode();
  }

  const urlPattern = /https?:\/\/[^\s<]+/g;
  textNodes.forEach(textNode => {
    const matches = [...textNode.data.matchAll(urlPattern)];
    if (!matches.length) return;

    const fragment = documentFragment.createDocumentFragment();
    let position = 0;
    matches.forEach(match => {
      const url = match[0];
      const index = match.index ?? 0;
      fragment.append(textNode.data.slice(position, index));
      const link = documentFragment.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.textContent = url;
      fragment.append(link);
      position = index + url.length;
    });
    fragment.append(textNode.data.slice(position));
    textNode.replaceWith(fragment);
  });

  return documentFragment.body.innerHTML;
}